module.exports = __webpack_public_path__ + "img/banner-poster-En.327b7cb5.png";